if (!customElements.get('nat-announcement')) {
  customElements.define('nat-announcement', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const button = this.querySelector('button');
      button?.addEventListener('click', () => {
        const paused = this.toggleAttribute('data-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? 'Play announcement' : 'Pause announcement');
        button.firstElementChild.textContent = paused ? '▷' : 'Ⅱ';
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
  });
}
